import {
  AfterContentChecked,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NgStringPipesModule } from 'ngx-pipes';
import { NgIf } from '@angular/common';
import {
  DxButtonComponent,
  DxPopupComponent,
  DxTemplateModule
} from 'devextreme-angular';


@Component({
  selector: 'gs-popup',
  templateUrl: './gs-popup.component.html',
  styleUrl: './gs-popup.component.sass',
  standalone: true,
  imports: [
    TranslatePipe,
    NgStringPipesModule,
    NgIf,
    DxButtonComponent,
    DxPopupComponent,
    DxTemplateModule,
  ]
})
export class GsPopupComponent implements AfterContentChecked {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title = '';
  @Input() subtitle = '';
  @Input() width: number | string = 900;
  @Input() height: number | string = 600;

  @Input() saving = false;

  @Output() save = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @ContentChild(FormGroupDirective)
  formGroupDirective?: FormGroupDirective;

  @ContentChild(NgForm)
  ngForm?: NgForm;


  hasForm = false;
  formDirty = false;


  ngAfterContentChecked() {
    const form = this.formGroupDirective?.form ?? this.ngForm?.form;

    this.hasForm = !!form;
    this.formDirty = !!form?.dirty;

  }

  get showSaveButton(): boolean {
    return this.hasForm && this.formDirty;
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit();
  }

  onSave() {
    this.save.emit();
  }
}
